<div class="page-content-wrapper">
  <div class="text-end">
      <img :src="$clientLogo" width="200px">
  </div>
  <div class="container-fluid content-card">
      <router-view :key="$route.fullPath"></router-view>
  </div>
</div>